import { Action } from '@ngrx/store';
import { Post } from './post.model';

export enum PostActionTypes {
  LoadPosts = '[Post] Load Posts',
  LoadPostsComplete = '[Post] Load Posts Complete'
}

export class LoadPosts implements Action {
  readonly type = PostActionTypes.LoadPosts;
}

export class LoadPostsComplete implements Action {
  readonly type = PostActionTypes.LoadPostsComplete;
  constructor(public payload: { posts: Post[] }) {}
}

export type PostActions = LoadPosts | LoadPostsComplete;
